import { hasPermission } from "utils/permissionsUtils";
import { PERMISSIONS } from "permissions/permissions";

// Job Details & Dropdowns
export const canViewJob = () =>
  hasPermission(PERMISSIONS.JOBS.JOB.VIEW);

export const canManageJobDropdown = () =>
  hasPermission(PERMISSIONS.JOBS.JOB.MANAGE_DROPDOWN);

export const canViewTradeSupplierTab = () =>
  hasPermission(PERMISSIONS.JOBS.JOB.TRADE_SUPPLIER_TAB);

export const canViewContractorBoysTab = () =>
  hasPermission(PERMISSIONS.JOBS.JOB.CONTRACTOR_BOYS_TAB);

export const canViewTeamCalendar = () =>
  hasPermission(PERMISSIONS.JOBS.JOB.TEAM_CALENDAR);

// Manage Job Actions
export const canViewManageJob = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.VIEW);

export const canCreateJob = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.CREATE);

export const canEditJob = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.EDIT);

export const canDeleteJob = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.DELETE);

// Manage Schedule Actions
export const canCreateSchedule = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.CREATESCHEDULE);

export const canEditSchedule = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.EDITSCHEDULE);

export const canExportScheduleTask = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.EXPORTSCHEDULE);

export const canDeleteScheduleTask = () => hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.DELETESCHEDULE);

export const canEditSelfAssignedTask = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.EDIT_SELF_ASSIGNED_TASK);

export const canManageJobStatus = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.MANAGE_STATUS);

export const canViewDraftTasks = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.VIEW_DRAFT_TASKS);

export const canCompleteAnyTask = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.COMPLETE_ANY_TASK);

export const canCompleteTradeWorkerTask = () =>
  hasPermission(PERMISSIONS.JOBS.MANAGE_JOB.COMPLETE_TRADE_WORKER_TASK);
